<template>
    <div id="lpnprint">
        <a-modal
                :title="$t('pubGicSet.PrePrintLPN')"
                v-model="visible"
                width="50%"
                :footer="null"
                @cancel="cancel"
        >
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('userlang.Warehouse') }}: </a-col>
                <a-col :span="14">
                    <a-select style="width: 90%" :placeholder="$t('publicLang.PleaseSelect')" v-model="warehouseVal" size="small" @change="warehoseChange">
                        <a-select-option v-for="item in warehouseData" :value="item.whsCode">{{item.whsName}}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>
            <a-row type="flex" justify="start" style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.LastPrinted') }}: </a-col>
                <a-col :span="12">{{LastLPN == null ? '---' : LastLPN}}</a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.NumberOfLPNLabelRequired') }}: </a-col>
                <a-col :span="14" >
                    <a-input-number :min="1" size="small" style="width: 80%;" v-model="count" :placeholder="$t('pubGicSet.NumberOfLPNLabelRequired')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printlpnbtn" :disabled="count == null || warehouseVal == undefined">{{ $t('pubGicSet.Print') }}</a-button>
                </a-col>
            </a-row>

            <a-row style="margin-bottom: 50px">
                <a-col :span="6" style="text-align:right;margin-right: 6px">{{ $t('pubGicSet.ReprintLPN') }}: </a-col>
                <a-col :span="14" >
                    <a-input size="small" style="width: 80%;" v-model="reprintLeftFromVal" :placeholder="$t('pubGicSet.ReprintLPN')"/>
                    <a-button size="small" type="primary" style="margin-left: 4px;" @click="printFromBtn" :disabled="reprintLeftFromVal == null">{{ $t('pubGicSet.Reprint') }}</a-button>
                </a-col>
            </a-row>

        </a-modal>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import axios from "axios";
    import cookie from "../../../api/cookie"
    export default{
        data(){
            return{
                visible: false,
                LastLPN: null,
                count: null,
                reprintLeftFromVal: null,
                warehouseData: [],
                warehouseVal: undefined
            }
        },
        methods:{
            warehoseChange(val){
                ajax.get(api.GENERICLASTLPN,{whsCode: val}).then(res=>{
                    this.LastLPN = res.data.LastLPN
                })
            },
            show(){
                this.warehouseVal = undefined
                this.visible = true
                ajax.get(api.USERDROPDOWNWHSPRINT).then(res=>{
                    this.warehouseData = res.data.warehouseList
                    if(this.warehouseData.length == 1){
                       this.warehouseVal = this.warehouseData[0].whsCode
                        ajax.get(api.GENERICLASTLPN,{whsCode: this.warehouseData[0].whsCode}).then(res=>{
                            this.LastLPN = res.data.LastLPN
                        })
                    }
                })
            },
            cancel(){
                    this.count = null
                    this.reprintLeftFromVal =  null
            },
            //            pdf 成功下载方法
            pubPdfUploadOk(data){
                this.isBtnajax = false
                this.$store.commit("updataLoading", { pbLoading: false });
                let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
                let url = window.URL.createObjectURL(blob);
                window.open(url);
            },
            // paf接口返回值处理
            pubPdfMsgfn(res){
                let data = res.data;
                let fileReader = new FileReader();
                let that = this
                fileReader.onload = function() {
                    try {
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code) {
                            that.$customMessage.warning(jsonData.msg);
                            that.$store.commit("updataLoading", { pbLoading: false });
                            that.isBtnajax = false
                        }
                    } catch (err) {
                        that.pubPdfUploadOk(res)
                    }
                };
                fileReader.readAsText(data)
            },
            printFromBtn(){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                        name: 'LPN_Label',
                        LPN1: this.reprintLeftFromVal,
                        whsCode: this.warehouseVal
                    }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    that.pubPdfMsgfn(res)
                })
            },
            printlpnbtn(){
                let ajaxurl = ajax.ajaxUrl();
                let that = this
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                        name: 'LPN_Label',
                        count: this.count,
                        whsCode: this.warehouseVal
                    }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
//                    Invalid LPN Number.
                    that.pubPdfMsgfn(res)
                })
            }
        }
    }

</script>